export function getSubscriptionNumberOrNullFromSubscriptions(subscriptions) {
  const subscriptionWithId = subscriptions.find((subscription) => !!subscription.subscription_number);
  if (subscriptionWithId) {
    return subscriptionWithId.subscription_number;
  }
  return null;
}
